import { useTranslation } from 'react-i18next';
import { NavigationItem } from '@cbridge-utils/navigation';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';

/**
 * Returns navigation items for reporting section
 * Always shows predefined list of reports without waiting for API response
 */
export const useReportingNavigation = () => {
  const { t } = useTranslation();

  const items: NavigationItem[] = [
    {
      kind: 'page',
      segment: RouteSegments.Reporting.Executions,
      title: t('text:navigation.reporting.bridgeExecutions'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Reporting.Orders,
      title: t('text:navigation.reporting.bridgeOrders'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Reporting.Exposure,
      title: t('text:navigation.reporting.exposure'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Reporting.TradingVolume,
      title: t('text:navigation.reporting.tradingVolume'),
    },
  ];

  // Add Conversion Rates as a separate item (not a Superset report)
  items.push({
    kind: 'page',
    segment: RouteSegments.Reporting.ConversionRates,
    title: t('text:navigation.reporting.conversionRates'),
  });

  return items;
};
